import { API } from "../api";
import axios from "axios";

const jsonHeaders = { "Content-Type": "application/json" };

export const createCustomer = async (payload) => {
  try {
    const { data } = await axios.post(`${API.DEV}/customer`, payload, {
      headers: jsonHeaders,
    });
    return data;
  } catch (err) {
    console.log(err);
    if (err.response?.data) return err.response.data;
    throw new Error(err);
  }
};

export const findAllCustomers = async (filters = {}) => {
  try {
    const { search, page = 1, limit = 50 } = filters;
    const params = new URLSearchParams();

    if (search) params.append("search", search);
    params.append("page", page);
    params.append("limit", limit);

    const queryString = params.toString();
    const url = `${API.DEV}/customer${queryString ? `?${queryString}` : ""}`;

    const { data } = await axios.get(url);

    if (data.success && Array.isArray(data.data)) {
      return data.data;
    }

    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.error("Error fetching customers:", err);
    return [];
  }
};

export const findCustomerByRut = async (rut) => {
  try {
    const { data } = await axios.get(`${API.DEV}/customer`, {
      params: { search: rut },
      headers: jsonHeaders,
    });

    if (data.success && Array.isArray(data.data)) {
      const customer = data.data.find((c) => c.customer_id === rut);
      return customer || null;
    }

    return null;
  } catch (err) {
    console.error("Error finding customer by RUT:", err);
    return null;
  }
};

export const findCustomerById = async (id) => {
  try {
    const { data } = await axios.get(`${API.DEV}/customer/${id}`);
    return data.success ? data.data : null;
  } catch (err) {
    console.error("Error finding customer by ID:", err);
    return null;
  }
};

export const updateCustomer = async (payload, id) => {
  try {
    const { data } = await axios.put(`${API.DEV}/customer/${id}`, payload, {
      headers: jsonHeaders,
    });
    return data;
  } catch (err) {
    console.error("Error updating customer:", err);
    throw new Error(err);
  }
};

export const deleteCustomer = async (id) => {
  try {
    const { data } = await axios.delete(`${API.DEV}/customer/${id}`);
    return data;
  } catch (err) {
    console.error("Error deleting customer:", err);
    throw new Error(err);
  }
};

export const getCustomerStats = async (id) => {
  try {
    const { data } = await axios.get(`${API.DEV}/customer/stats/${id}`);
    return data.success ? data.data : null;
  } catch (err) {
    console.error("Error getting customer stats:", err);
    return null;
  }
};
